import { render } from "./ChangeLang.vue?vue&type=template&id=63744db9&scoped=true&ts=true"
import script from "./ChangeLang.vue?vue&type=script&lang=ts"
export * from "./ChangeLang.vue?vue&type=script&lang=ts"

import "./ChangeLang.vue?vue&type=style&index=0&id=63744db9&scoped=true&lang=css"

import exportComponent from "G:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63744db9"]])

export default __exports__